import React from 'react'
// import balloon from 'assets/cathLabsLandingPage/cath-lab-device.png'
import balloon from 'assets/cathLabsLandingPage/Cath-Lab-Family-Image.webp'
import CE from 'assets/innvolution/carousel/logos/CE-2265.svg'

export default function Banner() {
  return (
    <section
      className=" bg-orange bg-[url(assets/bg-overlay/banner.webp)] bg-cover
      min-h-[480px] max-h-[500px] sm:min-h-[560px] sm:max-h-[650px] lg:h-[700px] lg:max-h-[700px] xl:max-h-[920px] h-screen 2xl:min-h-[800px] 2xl:h-screen min-h-none lg:pt-5 pt-14 bg-bottom bg-no-repeat 
    flex items-end"
    >
      <div className="flex overflow-hidden flex-col gap-0 pt-16 max-w-2xl h-full balloon-banner-wrapper 2xl:gap-10 2xl:pt-28 lg:pt-28 2xl:max-w-4xl w-container">
        <h3 className="font-medium text-center text-appear-anim basis-auto">
          Leverage the power of advanced cardiovascular imaging
        </h3>

        <div className="flex relative flex-1 items-end mx-auto mt-7 sm:items-start w-fit">
          <img
            className="h-10 opacity-40 absolute md:bottom-[24%] bottom-[2%] z-10 right-0 text-appear-anim-delayed w-auto object-contain object-bottom"
            src={CE}
            alt="CE logo"
          />
          <img
            className="object-contain object-bottom w-auto text-appear-anim-delayed"
            src={balloon}
            alt="Schematics of a cath lab showing all the part and components as manufactured by Innvolution labs- Cath labbs are a flagship product of Innvolution"
          />
        </div>
      </div>
    </section>
  )
}
